import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { useMenuDispatcher } from './menuContext';
import { NavigationItemLinkModel } from '../models/navigationItem.model';
import { googleNavClickEvent } from '../../../utils/analytics';
import { topMainMenu } from '../../../constants/analytics.constants';

const NavigationItemLink = ({ model }: { model: NavigationItemLinkModel }) => {
  const linkField = model.link;
  const textField = model.menuTitle;

  const dispatchToProvider = useMenuDispatcher();
  const handleClick = () => {
    dispatchToProvider({ type: 'closeAll' });
  };
  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink
        field={linkField}
        onClick={() => {
          googleNavClickEvent(topMainMenu, '#', textField?.value);
          handleClick();
        }}
        className="navigation__menu-item__trigger"
      >
        <RichText tag="div" className="navigation__menu-item__trigger__content rich-text" field={textField} />
      </RoutableSitecoreLink>
    </li>
  );
};

export default NavigationItemLink;
